/**
 * Route: /settlements — Stories 2.5 + 2.6 (v2-Relaunch, Welle 2)
 *
 * Abrechnungen. Kanonischer Nachfolger von /payouts (siehe sitemap.html
 * "Settlements"). Settlement-Uebersicht mit Filtern (Monat/Status/Host),
 * Payout-Sheet mit Solana-Pay-/Legacy-QR und Status-Umschalter.
 */
import { createFileRoute } from '@tanstack/react-router'
import { SettlementsPage } from '../features/settlements/SettlementsPage'

export const Route = createFileRoute('/_auth/settlements')({
  component: SettlementsPage,
})
